import request from '@/utils/request'
import { encrypt } from '@/utils/jsencrypt'

export function getPublicKey() {
    return request({
        url: 'mrsa/publicKey',
        method: 'get',

    })
}
// 登录
export function login(username, password) {
    const publicKey = localStorage.getItem("publicKey");
    if (!publicKey) {
        return Promise.reject("公钥不存在");
    }
 
    username = encrypt(publicKey, username);
    password = encrypt(publicKey, password);
    return request({
        url: '/agent/login',
        method: 'post',
        data: {
            username,
            password
        }
    })
}

// 获取验证码
export function getRestPasswordSMS(username, mobile) {
    return request({
        url: '/agent/personal/restPassword/sms',
        method: 'post',
        data: {
            username,
            mobile
        }
    })
}

// 校验验证码和帐号是否一致
export function getAuthTicket(username, mobile, code) {
    return request({
        url: '/agent/personal/getAuthTicket',
        method: 'post',
        data: {
            username,
            mobile,
            code
        }
    })
}

// 设置新密码
export function restPassword(password, reconfirm, ticket) {
    return request({
        url: '/agent/personal/restPassword',
        method: 'post',
        data: {
            password,
            reconfirm,
            ticket
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js